import React, { useState, useEffect } from 'react';
import { auth } from '../../firebase/firebaseConfig';
import { onAuthStateChanged } from 'firebase/auth';
import { useAuth } from '../../context/authContext';
const apiUrl = process.env.REACT_APP_API_URL;
const apiAirtimeUrl = apiUrl + '/api/v1/purchase-airtime';




//constant datatas
const defaultNetworkData = [
    { name: 'MTN', code: '01' },
    { name: 'GLO', code: '02' },
    { name: 'Airtel', code: '03' },
    { name: '9mobile', code: '04' },
];

const BuyAirtime = () => {
    const [user, setUser] = useState(null);
    const [mobileNumber, setMobileNumber] = useState('');
    const [amount, setAmount] = useState('');
    const [networks] = useState(defaultNetworkData);
    const [selectedNetwork, setSelectedNetwork] = useState(null);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const { currentUser } = useAuth();
    const [discounts, setDiscounts] = useState(null);

    useEffect(() => {
        fetch(apiUrl + '/api/v1/services/airtime-discounts')
            .then(res => res.json())
            .then(data => setDiscounts(data))
            .catch(err => console.error(err));
    }, []);

    const getPayableAmount = () => {
        const parsedAmount = parseFloat(amount) || 0;
        if (!parsedAmount || !selectedNetwork || !discounts || !currentUser) return parsedAmount;
        
        const netObj = networks.find(n => n.code === selectedNetwork);
        if (!netObj) return parsedAmount;
        
        let settingKey = netObj.name;
        if (settingKey === '9mobile') settingKey = 'NINE_MOBILE';
        else if (settingKey === 'Airtel') settingKey = 'AIRTEL';
        
        const role = String(currentUser.role || 'user').toLowerCase();
        let roleKey = 'regular';
        if (role === 'reseller' || role === 'upgraded_user') roleKey = 'upgraded';
        else if (role === 'api') roleKey = 'api';
        
        const netDiscounts = discounts[settingKey] || {};
        const pct = parseFloat(netDiscounts[roleKey]) || 0;
        
        return parsedAmount - (parsedAmount * (pct / 100));
    };



    //get current user from firebase
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
        });
        return () => unsubscribe();
    }, []);

    const getMessageColor = (msg) => {
        if (!msg) return '';
        const lowerMsg = String(msg).toLowerCase();
        if (lowerMsg.includes('success')) return 'text-green-500';
        if (lowerMsg.includes('insufficient') || lowerMsg.includes('try again') || lowerMsg.includes('warning')) return 'text-yellow-500';
        return 'text-red-500';
    };

    //validate form
    const validateForm = () => {
        if (!selectedNetwork) {
            setMessage('Please select a network provider.');
            return false;
        }

        if (mobileNumber.length !== 11 || isNaN(mobileNumber)) {
            setMessage('Please enter a valid 11-digit phone number.');
            return false;
        }

        const parsedAmount = parseInt(amount, 10);
        if (parsedAmount < 50) {
            setMessage('Amount must be at least ₦50.');
            return false;
        }

        return true;
    };

    const handlePurchase = async () => {
        setMessage(null);

        if (!user) {
            setMessage('Please log in to make a purchase.');
            return;
        }

        if (!validateForm()) {
            return;
        }

        setLoading(true);

        try {
            const idToken = await user.getIdToken();
            const payload = {
                MobileNetwork: selectedNetwork,
                Amount: amount.toString(),
                MobileNumber: mobileNumber
            };

            const response = await fetch(apiAirtimeUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${idToken}`
                },
                body: JSON.stringify(payload)
            });
            console.log('Response:', response);
            if (response.ok) {
                const data = await response.json();
                if (data.status === 'ORDER_RECEIVED') {
                    setMessage('Transaction successful');
                } else if (data.status === 'INSUFFICIENT_BALANCE'){
                    setMessage('PleaseTry again later');
                }else{
                    // 'AUTHENTICATION_FAILED_1','INVALID_INPUT_1','INVALID_INPUT_2','INVALID_INPUT_3'
                    setMessage('Transaction failed, contact support.');
                }
            } else {
                const errorData = await response.json().catch(() => ({}));
                let errorMessage = 'Failed to complete transaction';
                if (errorData.detail) {
                    if (typeof errorData.detail === 'string') {
                        errorMessage = errorData.detail;
                    } else if (Array.isArray(errorData.detail)) {
                        errorMessage = errorData.detail.map(err => `${err.loc[err.loc.length - 1]}: ${err.msg}`).join(', ');
                    }
                }
                
                if (errorMessage.toLowerCase().includes('insufficient balance')) {
                    errorMessage = 'Please try again later';
                }
                
                setMessage(errorMessage);
            }
        } catch (error) {
            console.error('Error during transaction:', error);
            setMessage('Failed to complete transaction.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="">
            <div className="bg-light2 dark:bg-dark1 text-dark0 dark:text-light1 space-y-6 w-full py-4 px-8 rounded-md">
                <div className="flex flex-col justify-center items-start space-y-2">
                    <h2 className="text-primary bg-light1 dark:bg-dark2 px-8 py-1 rounded-2xl">
                        Airtime Purchase
                    </h2>
                    <hr className="border-dark0 w-full" />
                </div>
                {!user ? (
                    <p className="text-red-400">Please log in to make a purchase.</p>
                ) : (
                    <>
                        <div>
                            <label>Network Provider:</label>
                            <select
                                className="outline-none border-none dark:bg-dark2 rounded-md h-10 px-2 w-full"
                                onChange={(e) => setSelectedNetwork(e.target.value)}
                                value={selectedNetwork}
                            >
                                <option value="">Select Network</option>
                                {networks.map((network) => (
                                    <option key={network.code} value={network.code}>
                                        {network.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label>Mobile Number:</label>
                            <input
                                className="outline-none border-none dark:bg-dark2 rounded-md h-10 px-2 w-full"
                                type="tel"
                                value={mobileNumber}
                                onChange={(e) => setMobileNumber(e.target.value)}
                                placeholder="Enter mobile number"
                            />
                        </div>
                        <div>
                            <label>Amount:</label>
                            <input
                                className="outline-none border-none dark:bg-dark2 rounded-md h-10 px-2 w-full"
                                type="number"
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                                placeholder="Enter amount (₦50 minimum)"
                            />
                        </div>
                        {amount && (
                        <div>
                            <label>Amount Payable:</label>
                            <div className="outline-none border-none bg-gray-100 dark:bg-gray-800 rounded-md h-10 px-2 w-full flex items-center text-gray-500 font-medium">
                                ₦{getPayableAmount().toFixed(2)}
                            </div>
                        </div>
                        )}
                        <button className="btn w-full" onClick={handlePurchase} disabled={loading}>
                            {loading ? 'Processing...' : 'Purchase Airtime'}
                        </button>
                    </>
                )}
                {message && <p className={getMessageColor(message)}>{message}</p>}
            </div>
        </div>
    );
};

export default BuyAirtime;

